<script setup lang="ts">
// A small busy indicator in the accent. `label` is read out to screen readers.
withDefaults(defineProps<{ label?: string; size?: number }>(), { label: 'Loading', size: 18 });
</script>

<template>
  <span class="itc-spinner" role="status" :aria-label="label" :style="{ width: `${size}px`, height: `${size}px` }"></span>
</template>

<style scoped>
.itc-spinner {
  display: inline-block;
  flex-shrink: 0;
  border: 2px solid color-mix(in srgb, var(--itc-accent) 25%, transparent);
  border-top-color: var(--itc-accent);
  border-radius: 50%;
  animation: itc-spin 0.8s linear infinite;
}
@keyframes itc-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
